export default "__VITE_ASSET__fd8a99be__"